import type { UpdatePaymentSettingsRequest, PaymentSettings } from '@/hooks/usePaymentSettings';
import { MOCK_PAYMENT_SETTINGS } from '@/lib/demo-data/payment-settings';

/** Mirrors the API: omitted fields keep their stored value and onboarding completion is write-once. */
export async function updatePaymentSettingsDemo(data: UpdatePaymentSettingsRequest): Promise<PaymentSettings> {
  let onboardingCompletedAtUtc = MOCK_PAYMENT_SETTINGS.onboardingCompletedAtUtc;
  let onboardingUpdatedAtUtc = MOCK_PAYMENT_SETTINGS.onboardingUpdatedAtUtc;

  if (data.onboardingCompleted !== undefined) {
    const onboardingWriteTimestamp = new Date().toISOString();
    onboardingUpdatedAtUtc = onboardingWriteTimestamp;
    onboardingCompletedAtUtc = data.onboardingCompleted ? (onboardingCompletedAtUtc ?? onboardingWriteTimestamp) : null;
  }

  return {
    ...MOCK_PAYMENT_SETTINGS,
    onboardingCompleted: data.onboardingCompleted ?? MOCK_PAYMENT_SETTINGS.onboardingCompleted,
    onboardingCompletedAtUtc,
    onboardingUpdatedAtUtc,
    bannerDismissed: data.bannerDismissed ?? MOCK_PAYMENT_SETTINGS.bannerDismissed,
    bannerUpdatedAtUtc:
      data.bannerDismissed === undefined ? MOCK_PAYMENT_SETTINGS.bannerUpdatedAtUtc : new Date().toISOString(),
  };
}
